"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-six/sections/testimonialSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type TestimonialSection4666sItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/patients/patient2.jpg" | "/Templates/Doccure/img/patients/patient3.jpg" | "/Templates/Doccure/img/patients/patient4.jpg" | "/Templates/Doccure/img/patients/patient5.jpg" | "/Templates/Doccure/img/patients/patient6.jpg" | "/Templates/Doccure/img/patients/patient7.jpg" */
    src: string;
    /** Detected variants: "Gregg Lewis" | "William Andre" | "Teresa Martin" | "Leslie Nichols" | "William Stark" */
    link0Text: ReactNode;
    /** Detected variants: "San Diego, CA" | "New York" | "Austin" | "San Francisco" | "Seattle" */
    p0Text: ReactNode;
    /** Detected variants: "Our cat, Milo, was nervous, but the vet handled him so gently. We’re so grateful for the kindness and expertise here." | "Our golden retriever, Max, had a severe ear infection, and the team here handled it with such care and patience." | "I’ve been bringing my pets here for over five years. Every visit feels personal, and I know my pets are in good hands." | "You can tell they genuinely love animals. The staff takes time to explain each procedure and follow up after visits." | "The clinic is spotless and well-equipped. I feel confident knowing my pet is getting the best care available." */
    p0P0Text: ReactNode;
    /** Detected variants: "col-xxl-4 col-xl-6 col-lg-6 col-md-6" */
    className?: string;
    /** Detected variants: "testimonial-item-six" */
    div0ClassName?: string;
    /** Detected variants: "testimonial-author" */
    div0ClassName2?: string;
    /** Detected variants: "testimonial-avatar" */
    div0ClassName3?: string;
    /** Detected variants: "patient1" */
    alt?: string;
    /** Detected variants: "img-fluid img-1" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "author" */
    div1ClassName?: string;
    /** Detected variants: "custom-title author-name" */
    h30ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "author-location" */
    p0ClassName?: string;
    /** Detected variants: "testimonial-content" */
    div1ClassName2?: string;
    reviewItems?: TestimonialSectionFaSolidFaStarsItem[];
};

type TestimonialSectionFaSolidFaStarsItem = {
    key: Key | null | undefined;
    /** Detected variants: "fa-solid fa-star" */
    className?: string;
};
export type HomeSixTestimonialSectionGeneratedProps = {
    divDiv0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialSection4666sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: TestimonialSection4666sItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div0Div1H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TestimonialSection4666sItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "Testimonials" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "What" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    /** Default: "Says Worldwide" */
    sectionDiv0Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Pet Parents" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    /** Default: "testimonial-img" */
    sectionDiv0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/reviews/testimonial-img.png" */
    sectionDiv0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "foot-prints" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/foot-prints-2.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "foot-prints" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/foot-prints-3.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    testimonialSection4666s: TestimonialSection4666sItem[];
    testimonialSection4666sItemWrapper?: (item: TestimonialSection4666sItem, content: ReactNode) => ReactNode;
    testimonialSection4666sRenderer?: (defaultNode: ReactNode) => ReactNode;
    testimonialSection4666sLinkVisible?: boolean;
    testimonialSection4666sLinkRenderer?: (item: TestimonialSection4666sItem, defaultNode: ReactNode) => ReactNode;
    testimonialSection4666sImageVisible?: boolean;
    testimonialSection4666sImageRenderer?: (item: TestimonialSection4666sItem, defaultNode: ReactNode) => ReactNode;
    testimonialSection4666sH3Visible?: boolean;
    testimonialSection4666sH3Renderer?: (item: TestimonialSection4666sItem, defaultNode: ReactNode) => ReactNode;
    testimonialSection4666sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TestimonialSection4666sItem) => Partial<ComponentProps<typeof SmartLink>>);
    testimonialSection4666sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialSection4666sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    testimonialSection4666sH3Props?: Partial<ComponentProps<"h3">> | ((item: TestimonialSection4666sItem) => Partial<ComponentProps<"h3">>);
    testimonialSectionFaSolidFaStarsItemWrapper?: (item: TestimonialSectionFaSolidFaStarsItem, content: ReactNode) => ReactNode;
    testimonialSectionFaSolidFaStarsRenderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeSixTestimonialSectionGenerated: FC<HomeSixTestimonialSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Testimonials",
    sectionDiv0Div0H20H2Text = "What",
    sectionDiv0Div0H20H2Text2 = "Says Worldwide",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Pet Parents",
    sectionDiv0ImageWithBasePath0ImageAlt = "testimonial-img",
    sectionDiv0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/reviews/testimonial-img.png",
    sectionDiv0ImageWithBasePath0ImageVisible,
    sectionDiv0ImageWithBasePath0ImageRenderer,
    sectionDiv0ImageWithBasePath0ImageProps,
    sectionImageWithBasePath0ImageAlt = "foot-prints",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/foot-prints-2.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "foot-prints",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/icons/foot-prints-3.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    divDiv0Div0Div0ImageWithBasePath0ImageProps,
    divDiv0Div0Div1H30H3Props,
    divDiv0Div0Div1H30Link0LinkProps,
    sectionDiv0Div1ClassName,
    testimonialSection4666s,
    testimonialSection4666sItemWrapper,
    testimonialSection4666sRenderer,
    testimonialSection4666sLinkVisible,
    testimonialSection4666sLinkRenderer,
    testimonialSection4666sImageVisible,
    testimonialSection4666sImageRenderer,
    testimonialSection4666sH3Visible,
    testimonialSection4666sH3Renderer,
    testimonialSection4666sLinkProps,
    testimonialSection4666sImageProps,
    testimonialSection4666sH3Props,
    testimonialSectionFaSolidFaStarsItemWrapper,
    testimonialSectionFaSolidFaStarsRenderer,
}) => {
    return (
        <section className="testimonial-section-six section">
            <div className="container">
                <div className="section-header-six text-center">
                    <div className="section-sub-title">{sectionDiv0Div0Div0DivText}</div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            <span className="line-6">{sectionDiv0Div0H20Span0SpanText}</span>
                            {sectionDiv0Div0H20H2Text2}
                        </h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-5"}>
                    {renderCollectionNode(
                        testimonialSection4666s,
                        (item: TestimonialSection4666sItem) => (
                            <div className={item.className ?? "col-xxl-4 col-xl-6 col-lg-6 col-md-6"} key={item.key}>
                                <div className={item.div0ClassName ?? "testimonial-item-six"}>
                                    <div className={item.div0ClassName2 ?? "testimonial-author"}>
                                        <div className={item.div0ClassName3 ?? "testimonial-avatar"}>
                                            {renderItemNode(testimonialSection4666sImageVisible, testimonialSection4666sImageRenderer, item, (
                                                <SmartImage src={item.src} alt={item.alt ?? "patient1"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-1"} {...(typeof testimonialSection4666sImageProps === "function" ? testimonialSection4666sImageProps(item) : (testimonialSection4666sImageProps ?? {}))} {...(typeof divDiv0Div0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                            ))}
                                        </div>
                                        <div className={item.div1ClassName ?? "author"}>
                                            {renderItemNode(testimonialSection4666sH3Visible, testimonialSection4666sH3Renderer, item, (
                                                <h3 className={item.h30ClassName ?? "custom-title author-name"} {...(typeof testimonialSection4666sH3Props === "function" ? testimonialSection4666sH3Props(item) : (testimonialSection4666sH3Props ?? {}))} {...(typeof divDiv0Div0Div1H30H3Props === "function" ? divDiv0Div0Div1H30H3Props(item) : (divDiv0Div0Div1H30H3Props ?? {}))}>
                                                    {renderItemNode(testimonialSection4666sLinkVisible, testimonialSection4666sLinkRenderer, item, (
                                                        <SmartLink href={item.href ?? "#"} {...(typeof testimonialSection4666sLinkProps === "function" ? testimonialSection4666sLinkProps(item) : (testimonialSection4666sLinkProps ?? {}))} {...(typeof divDiv0Div0Div1H30Link0LinkProps === "function" ? divDiv0Div0Div1H30Link0LinkProps(item) : (divDiv0Div0Div1H30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                    ))}
                                                </h3>
                                            ))}
                                            <p className={item.p0ClassName ?? "author-location"}>{item.p0Text}</p>
                                        </div>
                                    </div>
                                    <div className={item.div1ClassName2 ?? "testimonial-content"}>
                                        <p>{item.p0P0Text}</p>
                                    </div>
                                    <div className="review">
                                        {renderCollectionNode(
                                            item.reviewItems ?? [],
                                            (item: TestimonialSectionFaSolidFaStarsItem) => (
                                                <i className={item.className ?? "fa-solid fa-star"} key={item.key} />
                                            ),
                                            testimonialSectionFaSolidFaStarsItemWrapper,
                                            testimonialSectionFaSolidFaStarsRenderer
                                        )}
                                    </div>
                                </div>
                            </div>
                        ),
                        testimonialSection4666sItemWrapper,
                        testimonialSection4666sRenderer
                    )}
                </div>
                {renderNode(sectionDiv0ImageWithBasePath0ImageVisible, sectionDiv0ImageWithBasePath0ImageRenderer, (
                    <SmartImage src={sectionDiv0ImageWithBasePath0ImageSrc} alt={sectionDiv0ImageWithBasePath0ImageAlt} className="img-fluid testimonial-img-1" {...(sectionDiv0ImageWithBasePath0ImageProps ?? {})} />
                ))}
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid element-1" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="img-fluid element-2" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeSixTestimonialSectionGenerated;
